// extracted by mini-css-extract-plugin
module.exports = {"image-snippet":"_1lT03L","text-snippet":"_2Tpdn3"};